import React from "react";
import Blok from "../../../interfaces/Storyblok/Blok.interface";
import { StoryblokSplitSection } from "../../../interfaces/Storyblok/StoryblokSplitSection.interface";
import DynamicComponent from "../../utils/DynamicComponent/DynamicComponent.component";
import Crumb from "../../atoms/Crumb/Crumb.atom";

const SplitSection: React.FC<StoryblokSplitSection> = ({ crumb, title, contents = [] }) => {
  return (
    <section className="container mx-auto py-12 md:py-16">
      {crumb && <Crumb label={crumb} className="mb-6" />}

      {title && <h2 className="text-3xl font-extrabold leading-tight text-Body md:text-4xl">{title}</h2>}

      {!!contents.length && (
        <div className="mt-10 grid grid-cols-1 gap-10 md:grid-cols-2 md:gap-8 lg:gap-12">
          {contents.map((blok: Blok) => (
            <DynamicComponent key={blok._uid} blok={blok} />
          ))}
        </div>
      )}
    </section>
  );
};

export default SplitSection;
